import React from 'react'
import { connect } from 'react-redux'
import {
  addFlashMessage,
  hideLoader,
  showLoader,
  setAppointmentsBookingResult
} from '../../../actions'
import { BOOKING_TYPES } from '../constants'
import ConfirmMultipleAppointment from './ConfirmMultipleAppointment'
import ConfirmSingleAppointment from './ConfirmSingleAppointment'

const ConfirmAppointment = props => {
  if (props.bookingType === BOOKING_TYPES.MULTIPLE) {
    return <ConfirmMultipleAppointment {...props} />
  }

  return <ConfirmSingleAppointment {...props} />
}

function mapStateToProps({ auth, appointment }, ownProps) {
  const booking = appointment?.booking || {}

  return {
    patient: auth,
    auth,
    turn: booking.selectedTurn || ownProps.turn,
    cartTurns: booking.cartTurns || ownProps.cartTurns || [],
    clinics: booking.catalogs?.clinics || ownProps.clinics || [],
    bookingType: booking.mode || ownProps.bookingType || BOOKING_TYPES.SINGLE
  }
}

const mapDispatchToProps = {
  showLoader,
  hideLoader,
  addFlashMessage,
  setAppointmentsBookingResult
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAppointment)
